<div class="viewer-header">
  <h2>{{ data.titulo }}</h2>
  <div>
    <button mat-icon-button (click)="toggleFullscreen()" [matTooltip]="isFullscreen ? 'Sair da tela cheia' : 'Visualizar em tela cheia'">
      <mat-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
    </button>
    <button mat-icon-button mat-dialog-close matTooltip="Fechar">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="viewer-content">
  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Carregando documento...</p>
  </div>

  <div *ngIf="erro" class="erro-container">
    <mat-icon color="warn">error</mat-icon>
    <p>Erro ao carregar o documento. Verifique suas permissões.</p>
  </div>

  <ngx-extended-pdf-viewer
    *ngIf="!loading && !erro && pdfReady"
    [src]="pdfBlob!"
    [showToolbar]="true"
    [showDownloadButton]="false"
    [showPrintButton]="false"
    [showOpenFileButton]="false"
    [showPropertiesButton]="false"
    [showSecondaryToolbarButton]="false"
    [showSidebarButton]="false"
    [showRotateButton]="false"
    [showDrawEditor]="false"
    [showTextEditor]="false"
    [showStampEditor]="false"
    [showBorders]="false"
    [textLayer]="true"
    [theme]="'dark'"
    height="100%"
  ></ngx-extended-pdf-viewer>
</div>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="download()" [disabled]="loading || erro" *ngIf="data.mostrarDownload !== false">
    <mat-icon>download</mat-icon> Baixar arquivo PDF
  </button>
  <button *ngIf="data.mostrarEnvio !== false" mat-raised-button color="primary" (click)="confirmar()" [disabled]="loading || erro">
    Confirmar Envio ao SIGAD
  </button>
</mat-dialog-actions>
